/* eslint-disable import/no-anonymous-default-export */
import { useLocation } from 'react-router-dom'
import { useAppSelector } from '../store/hooks'
import { profileAwariRepository } from '@/repositories'

let profileDidInit = false
const blockedRoutes = ['/sair']

function useGetProfile() {
	const { pathname } = useLocation()

	const { signed } = useAppSelector((state) => state.auth)

	const { data, isLoading, isSuccess, isFetching, isError, refetch } =
		profileAwariRepository.useGetUserAwariQuery(undefined, {
			skip: !signed || blockedRoutes.includes(pathname),
			refetchOnMountOrArgChange: true,
		})

	if (!profileDidInit && data) {
		profileDidInit = true
	}

	return { data, isLoading, isSuccess, isFetching, isError, refetch }
}

export default {
	getProfileAwari: useGetProfile,
}
